import "flickity/js/index";

import Flickity from "flickity";

function startCarousel(carouselWrapper) {
	var carousel = carouselWrapper.querySelector(".carousel");

	var flkty = new Flickity(carousel, {
		setGallerySize: false,
    cellAlign: 'left',
    contain: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    pageDots: false
	});
}

function startCarousels() {
	let carousels = document.querySelectorAll(".atk-carousel");

	for (let index = 0; index < carousels.length; index++) {
		const carouselWrapper = carousels[index];
		startCarousel(carouselWrapper);
	}
}

startCarousels();
